var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import VueDialog from "../../interface/IVueDialog";
var renderTypeMap = {
    txt: 1,
    basic: 2,
    group: 3,
    new_group: 4,
    list_purchase: 13
};
var modelTypeMap = {
    deliver: 'deliver',
    good: 'good',
    specAndGood: 'specAndGood'
};
var ArticleList = (function (_super) {
    __extends(ArticleList, _super);
    function ArticleList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showCancelButton = false;
        _this.ePurOrderErrorCode = EPurOrderErrorCode;
        _this.renderTypeMap = renderTypeMap;
        _this.modelTypeMap = modelTypeMap;
        return _this;
    }
    ArticleList.prototype.created = function () {
        this.msg = this.resData.msg;
        if (this.modelType && this.modelType == this.modelTypeMap.deliver) {
            if (this.resData.code == 3 || this.resData.code == 58 || this.resData.code == 57) {
                this.renderType = this.renderTypeMap.basic;
            }
            else if (this.resData.code == 15 || this.resData.code == 16 || this.resData.code == 17 || this.resData.code === 8 || this.resData.code === 61) {
                this.renderType = this.renderTypeMap.group;
            }
            else {
                this.renderType = this.renderTypeMap.txt;
            }
            this.listData = this.resData.data;
            this.btntxt = this.sureButtonText ? this.sureButtonText : '知道了';
            return;
        }
        else if (this.modelType && this.modelType == this.modelTypeMap.good) {
            if (this.resData.code == 10 || this.resData.code == 12) {
                if (this.resData.data.msg_data && this.resData.data.msg_data.length) {
                    this.listData = this.resData.data.msg_data.map(function (item) {
                        return item.name;
                    });
                }
                else {
                    this.listData = [];
                }
                this.renderType = this.renderTypeMap.basic;
            }
            else if (this.resData.code == 18) {
                if (this.resData.data.msg_data && this.resData.data.msg_data.length) {
                    this.listData = this.resData.data.msg_data;
                }
                else {
                    this.listData = [];
                }
                this.renderType = this.renderTypeMap.group;
            }
            else {
                this.renderType = this.renderTypeMap.txt;
            }
            this.btntxt = this.sureButtonText ? this.sureButtonText : '知道了';
            return;
        }
        else if (this.modelType && this.modelType == this.modelTypeMap.specAndGood) {
            if (this.resData.code == 12) {
                if (this.resData.data.msg_data && this.resData.data.msg_data.length) {
                    this.listData = this.resData.data.msg_data.map(function (item) {
                        return item.name;
                    });
                }
                else {
                    this.listData = [];
                }
                this.renderType = this.renderTypeMap.basic;
            }
            else if (this.resData.code == 19 || this.resData.code == 20) {
                if (this.resData.data.msg_data && this.resData.data.msg_data.length) {
                    this.listData = this.resData.data.msg_data;
                }
                else {
                    this.listData = [];
                }
                this.renderType = this.renderTypeMap.group;
            }
            else {
                this.renderType = this.renderTypeMap.txt;
            }
            this.btntxt = this.sureButtonText ? this.sureButtonText : '知道了';
            return;
        }
        this.listData = this.resData.data;
        switch (this.resData.code) {
            case this.ePurOrderErrorCode.BUSINESS_GOODS_NOT_BIND:
                this.renderType = renderTypeMap.group;
                this.btntxt = this.sureButtonText ? this.sureButtonText : "去绑定";
                break;
            case this.ePurOrderErrorCode.GOODS_STOCK_IS_SHORT:
                this.renderType = renderTypeMap.basic;
                this.btntxt = this.sureButtonText ? this.sureButtonText : "去设置";
                break;
            case renderTypeMap.list_purchase:
                this.renderType = renderTypeMap.list_purchase;
                this.btntxt = this.sureButtonText ? this.sureButtonText : "去设置";
                break;
            default:
                this.renderType = renderTypeMap.txt;
                this.btntxt = this.sureButtonText ? this.sureButtonText : "知道了";
                break;
        }
    };
    ArticleList.prototype.close = function () {
        this.$closeDialog();
        this.$emit('addClient:ok', {});
    };
    ArticleList.prototype.cancel = function () {
        this.$closeDialog();
        this.$emit('addClient:cancel', {});
    };
    ArticleList = __decorate([
        Component
    ], ArticleList);
    return ArticleList;
}(VueDialog));
export default ArticleList;
